module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageLoaded === true),
      expression: "pageLoaded === true"
    }],
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-content"
  }, [(_vm.banner) ? _c('img', {
    attrs: {
      "src": _vm.banner,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "margin": "5px",
        "overflow": "hidden"
      }
    }, [_c('a', {
      attrs: {
        "href": ("/html/shop/cate/" + (item.id))
      }
    }, [_c('masker', {
      staticStyle: {
        "border-radius": "5px"
      },
      attrs: {
        "opacity": 0.5
      }
    }, [_c('div', {
      staticClass: "m-img",
      style: (("background-image:url(" + (item.logo) + ")"))
    }), _vm._v(" "), _c('div', {
      staticClass: "m-title",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_vm._v("\n                        " + _vm._s(item.name) + "\n                        "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "m-time"
    }, [_vm._v(_vm._s(item.description))])])])], 1)])
  })], 2), _vm._v(" "), _c('foot-nav', {
    attrs: {
      "selectBar": "shop"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01379e74"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/Index.vue
// module id = 636
// module chunks = 0